<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps(['content']);
const tags = ref([]);

onMounted(() => {
  const temp = document.createElement('div');
  temp.innerHTML = props.content.html;

  const children = Array.from(temp.children);

  const cleanedTags = children.map((el) => ({
    name: el.tagName,
    height: el.height || el.querySelector('iframe')?.height || 0,
    width: el.width || el.querySelector('iframe')?.width || 0,
    string: el.outerHTML,
  }));

  tags.value = cleanedTags;
});
</script>

<template>
  <div>
    <div v-for="tag in tags" :key="tag.name">
      <div :class="{ scale: tag.name === 'IFRAME' }" :style="tag.width && tag.height ? 'padding-bottom: ' + (tag.height / tag.width) * 100 + '%' : ''" v-html="tag.string" />
    </div>
  </div>
</template>
